export default __webpack_public_path__ + "static/media/faq.45e30142.svg";